export const aboutData = {
  brandName: '红桃视频',
  brandSlogan: '让每个人都能被发现',
  foundedYear: '2019',
  introduction: `红桃视频成立于2019年，是中国领先的高清短视频平台之一。我们致力于通过先进的技术和优质的内容生态，为每一位用户带来极致的短视频观看体验，同时为创作者提供展示才华、实现价值的舞台。

平台汇聚了来自全国各地的优秀创作者，涵盖搞笑、音乐、舞蹈、美食、旅行、科技、时尚、体育等丰富品类，日均视频上传量超过100万条，累计用户突破5亿。

我们相信，每个人都有值得被看见的闪光点。红桃视频通过智能推荐技术和公平的流量分配机制，让每一个好内容都能被发现，让每一位创作者都有机会实现梦想。`,

  stats: [
    { label: '累计用户', value: '5亿+', icon: 'ri-user-line' },
    { label: '日活用户', value: '8000万+', icon: 'ri-user-star-line' },
    { label: '入驻创作者', value: '300万+', icon: 'ri-edit-line' },
    { label: '日均上传', value: '100万+', icon: 'ri-upload-cloud-line' },
    { label: '覆盖国家', value: '30+', icon: 'ri-global-line' },
    { label: 'App评分', value: '4.9', icon: 'ri-star-line' },
  ],

  milestones: [
    { year: '2019', title: '红桃视频正式上线', description: '以高清短视频为核心，正式进入短视频赛道' },
    { year: '2020', title: '用户突破5000万', description: '凭借优质内容生态，快速积累用户基础' },
    { year: '2021', title: '上线创作者扶持计划', description: '投入亿元级资金扶持优质创作者' },
    { year: '2022', title: '用户突破3亿', description: '成为国内主流短视频平台之一' },
    { year: '2023', title: 'AI推荐系统升级', description: '全面升级智能推荐算法，用户体验大幅提升' },
    { year: '2024', title: '国际化战略启动', description: '覆盖30+国家和地区，开启全球化征程' },
    { year: '2025', title: '用户突破5亿', description: '电商、本地生活等多元业务蓬勃发展' },
    { year: '2026', title: '创作者大会盛况空前', description: '3000+创作者齐聚，共建内容新生态' },
  ],

  testimonials: [
    {
      name: '美食家老王',
      avatarUrl: 'https://readdy.ai/api/search-image?query=warm%20coral%20gradient%20abstract%20avatar%20style%20minimalist%20background%2C%20soft%20lighting%2C%20clean%20composition%2C%20no%20text%20no%20logos&width=100&height=100&seq=testimonial-01&orientation=squarish',
      title: '知名美食创作者',
      content: '红桃视频给了我展示厨艺的舞台。从默默无闻到千万粉丝，感谢平台对创作者的真诚支持。推荐算法真的很懂用户，我的视频总能被对美食感兴趣的人看到。',
      followers: '1200万',
    },
    {
      name: '音乐旅人小李',
      avatarUrl: 'https://readdy.ai/api/search-image?query=warm%20amber%20gradient%20abstract%20avatar%20style%20minimalist%20background%2C%20soft%20lighting%2C%20clean%20composition%2C%20no%20text%20no%20logos&width=100&height=100&seq=testimonial-02&orientation=squarish',
      title: '独立音乐人',
      content: '在红桃视频发布的第一首原创歌曲就获得了百万播放，这是我之前想都不敢想的。平台对原创内容的保护做得很好，变现渠道也很丰富。',
      followers: '580万',
    },
    {
      name: '旅行达人阿杰',
      avatarUrl: 'https://readdy.ai/api/search-image?query=warm%20terracotta%20gradient%20abstract%20avatar%20style%20minimalist%20background%2C%20soft%20lighting%2C%20clean%20composition%2C%20no%20text%20no%20logos&width=100&height=100&seq=testimonial-03&orientation=squarish',
      title: '旅行博主',
      content: '红桃视频的画质是我用过所有平台里最好的，高清呈现让旅行视频的视觉效果拉满。智能推荐也让我的内容能被真正热爱旅行的人发现。',
      followers: '890万',
    },
    {
      name: '科技评论员大刘',
      avatarUrl: 'https://readdy.ai/api/search-image?query=warm%20golden%20gradient%20abstract%20avatar%20style%20minimalist%20background%2C%20soft%20lighting%2C%20clean%20composition%2C%20no%20text%20no%20logos&width=100&height=100&seq=testimonial-04&orientation=squarish',
      title: '数码评测创作者',
      content: '作为科技创作者，我很看重平台的画质和剪辑工具。红桃视频在这两方面都做得非常出色。平台对知识类内容的流量扶持力度也很大。',
      followers: '450万',
    },
  ],

  contactInfo: {
    address: '浙江省杭州市余杭区未来科技城红桃大厦18层',
    phone: '400-888-6666',
    email: 'contact@hongtaovideo.com',
    businessHours: '周一至周五 9:00 - 18:00',
  },
};